import apiClient from './apiClient'

export interface Message {
  id: number
  subject: string
  created_at: string
  recipient?: string
  to_address?: Record<string, string>
}

export interface MessagesResponse {
  current: number
  total: number
  last: number
  data: Message[]
}

export interface MessageDetail {
  id: number
  subject: string
  recipient: string
  recipients_to?: string[]
  recipients_cc?: string[]
  recipients_bcc?: string[]
  reply_to?: string
  created_at: string
  delay?: number
  event?: string
  description?: string
  body_html?: string
  fk_mailgun_log_id?: number
  attachments?: (string | AttachmentObject)[]
  to_address?: Record<string, string>
}

export interface AttachmentObject {
  filename: string
  attachment_path: string
  attachment_name?: string
  attachment_size?: number
}

export interface MessagesParams {
  perPage?: number
  page?: number
  to?: string
  type?: string
  fromDt?: string
  toDt?: string
}

export async function fetchMessages(params: MessagesParams = {}): Promise<MessagesResponse | Message[]> {
  const requestParams: MessagesParams = {
    perPage: params.perPage || 15,
    page: params.page || 1,
    type: 'database',
    ...params,
  }

  const response = await apiClient.get('/api/applicant_mail_list', { params: requestParams })
  return response.data
}

export async function fetchMessageDetail(mailId: number): Promise<MessageDetail> {
  const response = await apiClient.get(`/api/mailgun_logs/${mailId}`)
  return response.data
}
